export default "__VITE_ASSET__yZygd7bL__"